
/** 获取页面元素各个点位 。。。。。。。。 */
export function getAllPosition(params) {
  let answerSheet = params
  return getStudentInfoPosition(answerSheet)
 }
 // 获取考生区域
 function getStudentInfoPosition(answerSheet,el, pageIndex) {
   // let dom = document.querySelectorAll('.basics-info')
   let positions = []
   // 
   let limitEls = document.querySelectorAll('.preview_wrapper_row')
   //
   let page = document.querySelectorAll('.preview-wrapper .page-cell')

   page.forEach((boxEl, index) => {
     let pageIndex = index;
     // 考生信息
     let basicInfo = getBasicReact(pageIndex, boxEl,answerSheet)
     console.log('考生信息=====log', basicInfo);
     // 客观题
     let objective = getObjectiveReact(pageIndex, boxEl)
     console.log('客观题=====log', objective);
     // 填空题
     let fill = getFillReact(pageIndex, boxEl)
     console.log('填空题=====log', fill);
     // 解答题
     let answer = getAnswerReact(pageIndex, boxEl)
     console.log('解答题=====log', answer);
     // 作文
     let writeCN = getWriteCNReact(pageIndex, boxEl)
     console.log('作文=====log', writeCN);
     // 英文作文
     let writeEN = getWriteENReact(pageIndex, boxEl)
     console.log('英文作文=====log', writeEN);
     // 选做  
     let choose = getOptionalReact(pageIndex, boxEl)
     console.log('选做=====log', choose);
     // 禁止作答
     let limitInfo = getLimitReact(pageIndex, limitEls[index])
     console.log('禁止作答区域=====log', limitInfo);
     // 打分
     let score = getMuaranteePosition(pageIndex, boxEl)
     console.log('打分=====log', score);

     // --增加 学生信息区域
     let stu_info = getStuInfoReact(pageIndex, boxEl)
     console.log('学生信息区域=====log', stu_info);

     // --增加 四点定位区域
     let squares = getSquaresReact(pageIndex, boxEl)
     console.log('四点定位区域=====log', squares);
     // 总分
     positions.push({
       pageIndex,
       basicInfo,
       objective,
       fill,
       answer,
       writeCN,
       writeEN,
       choose,
       limitInfo,
       score,
       stu_info
     })
 
   });
   // 
   console.log('positions=====log', positions);
 
   return positions
 }
 // 获取元素相对于容器的坐标
function getRelativeRect(el, container) {
  const containerRect = container.getBoundingClientRect()
  const elRect = el.getBoundingClientRect()
  
  return {
    x: elRect.left - containerRect.left,
    y: elRect.top - containerRect.top,
    w: elRect.width,
    h: elRect.height,
    // right: elRect.right - containerRect.left,
    // bottom: elRect.bottom - containerRect.top
  }
}

function getRelativeRectKh(el, container) {
  const containerRect = container.getBoundingClientRect()
  const elRect = el.getBoundingClientRect()
  
  return {
    x: elRect.left - containerRect.left,
    y: elRect.top - containerRect.top,  
    w: elRect.width,
    h: elRect.height,
    // right: elRect.right - containerRect.left,
    // bottom: elRect.bottom - containerRect.top
  }
}
//四点定位区域
function getSquaresReact(pageIndex, boxEl){

}
//学生信息区域
function getStuInfoReact(pageIndex, boxEl){

  const container = boxEl?.closest('.page-cell');
  const objEl = boxEl?.querySelector('.basics');
  if (!objEl) return [];

  let objrect = getRelativeRect(objEl, container);

  let objRectInfo = { 
    ...objrect,
    pageIndex, 
  };
  return objRectInfo
}

 // 手批
 function  getMuaranteePosition(pageIndex, boxEl) {
   let objRectInfo = {
     pageIndex,
     children: []
   }
   let objEls = boxEl.querySelectorAll('.score-con')
   objEls && objEls.forEach((el, index) => {
     let obj = {
       children: []
     }
     obj.outRect = el.getBoundingClientRect() 
     //
     let childs = el.querySelectorAll('.score-cell')
     let scores = []
     childs.forEach((child, index) => {
       child.innerText.length > 0 && scores.push(child.innerText)
     })
     let tenScore = scores.filter(tem => tem == '0')
     if(tenScore && tenScore.length >=2){
       let index = scores.findIndex(item => item == '0')
       tenScore = scores.slice(0,index)
     }
     console.log('tenScore=====log',tenScore);
     let isOne = false
     childs.forEach((child, index) => {
       let scoreObj = {}
       scoreObj.outRect = child.getBoundingClientRect()
       let text = child.innerText
       isOne = text == '9' ? true : isOne
       scoreObj.outRect.value =  text
       if(tenScore && tenScore.length > 0 && !isOne){
         let hasTen = tenScore.some(item => item == text)
         if(hasTen){
           scoreObj.outRect.value =  Number(text) * 10
         }
       }
       obj.children.push(scoreObj)
     })
     objRectInfo.children.push(obj)
   })
   return objRectInfo
 }
 // 禁止作答区域
 function getLimitReact(pageIndex, boxEl) {
   let objRectInfo = {
     pageIndex,
   }
   let objEl = boxEl ? boxEl.querySelector('.position_remind_text') : null
   objRectInfo.outRect = objEl ? objEl.getBoundingClientRect() : null
  //  if (objRectInfo.outRect) {
  //    objEl.squareRect = squarePosition(objRectInfo.outRect)
  //  }
   return objRectInfo
 }
 // 填空题
 function getFillReact(pageIndex, boxEl){

    const container = boxEl.closest('.page-cell')
    let objs = boxEl ? boxEl.querySelector('.fill-warp') : null

    //let fillBox = objs ? objs.getBoundingClientRect() :null
    let fillReact = []
    if(objs){
      let khRec = getRelativeRect(objs,container)
      fillReact = {
        ...khRec,
        pageIndex: pageIndex,
        children: []
      }
    }
      // let items = objs.querySelectorAll('.fill-item')
      // items.forEach((ict, index) => {
      //   //let react = ict.getBoundingClientRect()
      //   let itemInfos = getRelativeRect(ict,container)
      //   fillReact.children.push(itemInfos)
      // })
    return fillReact
  }
 // 选做题
 function getOptionalReact(pageIndex, boxEl) {
   let objRectInfo = {
     pageIndex,
     children: []
   }
   let objEls = boxEl.querySelector('.choose-cont')
   objEls && objEls.forEach((el, index) => {
     let obj = {}
     obj.outRect = el.getBoundingClientRect() 
    //  if (obj.outRect) {
    //    obj.squareRect = squarePosition(obj.outRect)
    //  }
     objRectInfo.children.push(obj)
   })
   return objRectInfo
 }
 // 英语作文
 function getWriteENReact(pageIndex, boxEl) {
   let objRectInfo = {
     pageIndex,
     children: []
   }
   let objEls = boxEl.querySelectorAll('.en-cont')
   objEls && objEls.forEach((el, index) => {
     let obj = {}
     obj.outRect = el.getBoundingClientRect() 
    //  if (obj.outRect) {
    //    obj.squareRect = squarePosition(obj.outRect)
    //  }
     objRectInfo.children.push(obj)
   })
   return objRectInfo
 }
 // 作文
 function getWriteCNReact(pageIndex, boxEl) {
   let objRectInfo = {
     pageIndex,
     children: []
   }
   let objEls = boxEl.querySelectorAll('.writing-cont')
   objEls && objEls.forEach((el, index) => {
     let obj = {}
     obj.outRect = el.getBoundingClientRect() 
    //  if (obj.outRect) {
    //    obj.squareRect = squarePosition(obj.outRect)
    //  }
     objRectInfo.children.push(obj)
   })
   return objRectInfo
 }
 // 解答题
 function getAnswerReact(pageIndex, boxEl) {
   let objRectInfo = {
     pageIndex,
     children: []
   }
   let objEls = boxEl.querySelectorAll('.answer-cont')
   objEls && objEls.forEach((el, index) => {
     let obj = {}
     obj.outRect = el.getBoundingClientRect() 
    //  if (obj.outRect) {
    //    obj.squareRect = squarePosition(obj.outRect)
    //  }
     objRectInfo.children.push(obj)
   })
 
   return objRectInfo
 }
 // 客观题
 function getObjectiveReact(pageIndex, boxEl) {

  const container = boxEl?.closest('.page-cell');

  const objEl = boxEl?.querySelector('.obj-cont');
  if (!objEl) return [];

  let objrect = getRelativeRect(objEl, container);

  let objRectInfo = { 
    ...objrect,
    pageIndex, 
    children: [] 
  };

  const objGroups = objEl.querySelectorAll('.obj-group');

  objGroups.forEach((group, index) => {
    const grect = getRelativeRect(group, container);
    const gdata = { ...grect, index, children: [] };

    const childs = group.querySelectorAll('.group'); 

    childs.forEach((child) => {
      const crect = getRelativeRect(child, container);
      const t = { ...crect, children: [], tHao: '' };

      // 处理选项（略）
      const tOptions = child.querySelectorAll('.gro-item .value');
      tOptions.forEach((option, idx) => {
        if (idx === 0) {
          t.tHao = option.innerText;
        }else{
          const items = getRelativeRect(option, container);
          let thText = option.innerText
          t.children = t.children || [];
          t.children.push({
            ...items,
            text: thText.replace(/^\[|\]$/g, '')
          });
        }
      });

      gdata.children.push(t);
    });

    objRectInfo.children.push(gdata);
  });

  return objRectInfo;
}
 // 获取主观题四角位置
function squarePosition(rect) {
   let {
     x,
     y,
     width,
     height
   } = rect
   let position = {
     topLeftReact: {
       x,
       y
     },
     topRightReact: {
       x: x + width,
       y
     },
     bottomLeftReact: {
       x,
       y: y + height
     },
     bottomRightReact: {
       x: x + width,
       y: y + height
     }
   }
   return position
 }
 // 考生信息
 function getBasicReact(pageIndex, boxEl,answerSheet) {
  // 获取容器基础坐标
  const container = boxEl ? boxEl.closest('.page-cell') : null
  const containerRect = container.getBoundingClientRect()
   // 考生信息容器
  const basicsInfo = boxEl ? boxEl.querySelector('.basics_info') : null

   // 填涂信息
   let fillInfo = {
     pageIndex
   }
   // 考生信息
   //let basicsInfo = boxEl.querySelector('.basics_info');
   const pageRect = boxEl.getBoundingClientRect();
   if (!basicsInfo) {
     fillInfo = basicsInfo ? basicsInfo.getBoundingClientRect() : null
     return fillInfo
   }

  //新增 条码粘贴区
  const barCode = boxEl ? boxEl.querySelector('.basics-bar-code') : null

  let barcodeInfo = []
  if(barCode){
    let codeRec = getRelativeRect(barCode,container)
    barcodeInfo = {
      ...codeRec,
      pageIndex
    }
  }
  fillInfo.codeInfo = barcodeInfo

   //  考号 座位
   let iconts = basicsInfo.querySelectorAll('.i-cont')
   let names = basicsInfo.querySelectorAll('.i-name')

   let khRec = getRelativeRect(basicsInfo,container)
  
   let kaohaoRec = {
      ...khRec,
      pageindex: pageIndex,
      children: []
   }
   let kaohaoRectData = []
   iconts.forEach((ict, index) => {
     let react = ict.getBoundingClientRect()
     
     let kaohaoInfos = getRelativeRect(ict,container)
     
     kaohaoRectData = {
        ...kaohaoInfos,
        name: names[index].innerText,
        type: kaohaoType(names[index].innerText)
     }
    //  kaohaoInfos ={
    //    x: react?.x ?? 0, 
    //    y: react?.y ?? 0, //去除顶部 bar 高度
    //    w: react?.width ?? 0,
    //    h: react?.height ?? 0,
    //    name: index,
    //    type: kaohaoType(name)
    //  }
     kaohaoRec.children.push(kaohaoRectData)
   })
   fillInfo.kaohaoInfo = kaohaoRec
   console.log('kaohaoInfos=====log', kaohaoRec);
   // 准考证号
   let zkNumEl = boxEl ? boxEl.querySelector('.f-empty') : null
   let zkInfo = {
     children: []
   }
   // 外部框
   //let zkRect = zkNumEl ? zkNumEl.getBoundingClientRect() :null
   if(zkNumEl){
    let zkRect = getRelativeRect(zkNumEl,container)

    zkInfo = {
       ...zkRect,
       pageindex: pageIndex,
       children: []
    }
   }

   // 内部空
   let zkEmptys = zkNumEl ? zkNumEl.querySelectorAll('.empty') : []
   zkEmptys.forEach((empty, index) => {
     //let react = empty.getBoundingClientRect()
     let obj = getRelativeRect(empty,container)

     zkInfo.children.push(obj)
   })
   fillInfo.zkInfo = zkInfo
   console.log('准考证=====log', zkInfo);
   // 填涂信息
  
   let fillEl = boxEl ? boxEl.querySelector('.f-fill') : null
   let tiantuInfo = {
    children: []
  }
   //let ttRect = fillEl ? fillEl.getBoundingClientRect() : null
  if(fillEl){
    let ttRect = getRelativeRect(fillEl,container)

    tiantuInfo = {
     ...ttRect,
     pageindex: pageIndex,
     children: []
  }
  }
   // 内部空
   let fillEmptys = fillEl ? fillEl.querySelectorAll('.fill'): []
   let fillArray = []
   fillEmptys.forEach((empty, index) => {
     //let react = empty.getBoundingClientRect()
     let react = getRelativeRect(empty,container)
     let obj = {
       ...react,
       pageindex: pageIndex,
       children: []
     }
     let childs = empty.querySelectorAll('.f-num span')
     childs.forEach((child, index) => {
       //let react = child.getBoundingClientRect()
       let react = getRelativeRectKh(child,container)
       let obj2 = {
        ...react,
        name: index
      }
       react.value = index
       obj.children.push(obj2)
     })
     fillArray.push(obj)
   })
   tiantuInfo.children = fillArray
   fillInfo.tiantuInfo = tiantuInfo

   console.log('填涂=====log', fillInfo);
   return fillInfo
 }
 
 function kaohaoType(key) {
   let types = [{
     name: '姓名',
     value: 1
   }, {
     name: '学校',
     value: 2
   }, {
     name: '班级',
     value: 3
   }, {
     name: '考号',
     value: 4
   }, {
     name: '专业',
     value: 5
   }, {
     name: '考场',
     value: 6
   }, {
     name: '座位',
     value: 7
   }]
   let index = types.findIndex(item => item.name == key)
 
   return index != -1 ? types[index].value : ''
 }
 function extractTH(str) {
  const match = str.match(/$$([A-Z]+)$$/);
  return match ? match[1] : null;
}